import React, { useState, useEffect } from 'react';
import { FcGoogle } from 'react-icons/fc';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const location = useLocation();
  
  // Check for error in URL (from redirects)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const errorParam = params.get('error');
    if (errorParam) {
      setError(`Authentication error: ${errorParam}`);
    }
  }, [location]);
  
  const handleLogin = async () => {
    setIsLoading(true);
    setError(null);
    try {
      await login();
    } catch (err: any) {
      console.error('Login error:', err);
      // Check if this is an error with details
      if (err.response && err.response.data && err.response.data.detail) {
        const detail = err.response.data.detail;
        setError(typeof detail === 'string' ? detail : detail.message || 'Failed to initiate login');
        

      } else {
        setError(err.message || 'Failed to initiate login');
      }
    } finally {
      setIsLoading(false);
    }
  };
  


  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-900 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-center text-gray-800 dark:text-white mb-8">
          Accedi per visualizzare i documenti
        </h1>
        <p className="mb-6 text-center text-gray-600 dark:text-gray-300">
          Devi autenticarti con Google per accedere ai documenti di Google Drive
        </p>
        
        {error && (
          <div className="mb-6 bg-red-100 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded p-4">
            <h3 className="text-lg font-semibold text-red-800 dark:text-red-300">Errore di Autenticazione</h3>
            <p className="text-red-700 dark:text-red-300">{error}</p>
            

          </div>
        )}
        
        <button
          onClick={handleLogin}
          disabled={isLoading}
          className="w-full flex items-center justify-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-md transition duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
        >
          <FcGoogle className="text-xl bg-white rounded-full" />
          <span>Accedi con Google</span>
          {isLoading && (
            <span className="ml-2 animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></span>
          )}
        </button>
      </div>
    </div>
  );
};

export default LoginPage; 